import { render } from "./Result.vue?vue&type=template&id=61dd7200&scoped=true&lang=pug"
import script from "./Result.vue?vue&type=script&setup=true&lang=js"
export * from "./Result.vue?vue&type=script&setup=true&lang=js"

import "./Result.vue?vue&type=style&index=0&id=61dd7200&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61dd7200"]])

export default __exports__